import { render, staticRenderFns } from "./addFileControl.vue?vue&type=template&id=39ab7b06&scoped=true&"
import script from "./addFileControl.vue?vue&type=script&lang=js&"
export * from "./addFileControl.vue?vue&type=script&lang=js&"
import style0 from "./addFileControl.vue?vue&type=style&index=0&id=39ab7b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab7b06",
  null
  
)

export default component.exports